export default __webpack_public_path__ + "static/hp-brand-deck-06-a7e2668ce270c69f6bfd506bf86de7f0.png";